import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import css from './CopyInput.module.css';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

export type CopyInputProps = {
  value: string;
  className?: string;
};

export const CopyInput = ({value, className}: CopyInputProps) => {
  const [copied, setCopy] = useState(false);
  const copyInputValue = () => {
    navigator.clipboard.writeText(value);
    setCopy(true);
    setTimeout(() => setCopy(false), 1000);
  };

  return (
    <div className={classNames(css.root, className)}>
      <input type="text" value={value} readOnly className={css.input} />

      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="copy-input-btn-overlay" className={css.tooltip}>
            {copied ? 'Copied!' : 'Copy'}
          </Tooltip>
        }
      >
        <button className={css.button} onClick={copyInputValue}>
          <FontAwesomeIcon icon={faCopy as any} size="2x" />
        </button>
      </OverlayTrigger>
    </div>
  );
};
